import React from 'react';
import PropTypes from 'prop-types';
import colors from 'customizations/js/color-variables';

export const IconProducerChecked = ({ className }) => (
  <svg className={className} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10Z" fill={colors.primary} />
    <path fillRule="evenodd" clipRule="evenodd" d="M15.3475 8.22047C15.8399 7.72815 15.8399 6.92993 15.3475 6.4376C14.8552 5.94528 14.057 5.94528 13.5647 6.4376L9.05277 10.9495L6.79222 8.6888C6.29991 8.19646 5.50169 8.19643 5.00935 8.68874C4.51701 9.18104 4.51698 9.97926 5.00929 10.4716L8.16098 13.6235C8.48128 13.9438 8.93106 14.0558 9.34185 13.9593C9.56275 13.9076 9.77241 13.7956 9.94463 13.6234L15.3475 8.22047Z" fill="white" />
    <path d="M10 19C5.02944 19 1 14.9706 1 10H-1C-1 16.0751 3.92487 21 10 21V19ZM19 10C19 14.9706 14.9706 19 10 19V21C16.0751 21 21 16.0751 21 10H19ZM10 1C14.9706 1 19 5.02944 19 10H21C21 3.92487 16.0751 -1 10 -1V1ZM10 -1C3.92487 -1 -1 3.92487 -1 10H1C1 5.02944 5.02944 1 10 1V-1Z" fill={colors.primary} />
  </svg>
);

IconProducerChecked.propTypes = {
  className: PropTypes.string
};

IconProducerChecked.defaultProps = {
  className: ''
};
